import styled from "styled-components";
import Layout from "../Layout/Layout";
import Seo from "../Layout/Seo/Seo";

const IFrame = styled.iframe`
  border: none;
  width: 100%;
  height: calc(100vh + 85px);
  margin-top: -90px;
`;

const ComplaintSystem = () => {
  return (
    <Layout authRequired={false} hideFooter={true}>
      <Seo
        title="Whistleblower- / Hinweisgeberschutz gem. Hinweisgeberschutzgesetz (HinSchG)"
        description="Meldesystem für Hinweisgeber/Whistleblower."
      />
      <IFrame src="https://www.bayka.de/unternehmen/beschwerdesystem/" />
    </Layout>
  );
};
export default ComplaintSystem;
